// Environment-specific hosts, supplied by the server at page load.
//
// These used to be hostname maps listing every environment, which meant a
// production bundle shipped the beta hostnames to anyone who opened the
// JavaScript. Node now injects only this environment's values into index.html
// as `window.__APP_CONFIG__` (see 9696-node/server.js), sourced from env.json
// and secrets.yaml, which are already deployed per environment.
//
// Nothing needs to be configured on the build machine, and changing a host
// needs a Node restart rather than a rebuild.

const appConfig = () => (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};

// This app's own Node API is always on the same origin as the page, so no
// configuration is needed at all. Local development is the exception: the
// React dev server runs on :3000 while Node runs on :1300.
export const urlDomain = () =>
  process.env.NODE_ENV === 'development' ? 'http://localhost:1300/api' : '/api';

// Base URL of the WebERP host serving the DSR, WhatsApp, Invoice, attachment
// and Activity Chart pages the app links to or embeds.
export const erpDomain = () => appConfig().erpUrl || '';

// Base URL of the vendors portal itself, for the PHP pages the app embeds or
// opens (Connect Seller, contact details, disposition admin).
export const portalDomain = () => appConfig().portalUrl || '';
